module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.d61fddb0.png";